export interface SaveOrUpdateAttributeRequest {
  uuid: string
  domId: number
  domType: number
  attrValue: string
}
export interface SaveOrUpdateAttributeResponse {
  status?: number
  message?: number
}

export enum UuidType {
  /**
   * To update user preferences so to persist stock filter selection
   */
  PARTS_USER_FILTER_LEVEL = 'PARTS_USER_FILTER_LEVEL',
  /**
   * To update user preferences when labor rates are updated.
   */
  LABOR_RATE = 'LABOR_RATE',
  /**
   * To update user default language, when language is updated.
   */
  SELECTED_LANGUAGE = 'DEFAULT_LANGUAGE',
  /**
   * To update user preferences when sort order is updated in search results page.
   */
  DISPLAY_SORTORDER = 'DISPLAY_SEQ_MULTIPLE',
  SHOW_YOUR_COST = 'PRICE_FIELD_DEFAULTS',
  MISCPREFERENCES_DEFAULTS = 'MISC_PREFERENCES',
}

export enum OrgType {
  LOC = 'loc',
  REG = 'reg',
  WD = 'wd',
}
export enum DomType {
  /**
   * User
   */
  USR = '5',

  /**
   * location
   */
  LOC = '4',
  /**
   * store
   */
  REG = '3',
  /**
   * Warehouse
   */
  WD = '2',
}
